module.exports = __webpack_public_path__ + "img/veg.b9bc2169.svg";